import PropTypes from 'prop-types';
import { Box, Button, Container } from '@mui/material';
import VehicleRecordTable from 'src/components/vehicles/VehicleRecordTable';
import FMSToolbar from 'src/common/FMSToolbar';
import FilterSelectInput from 'src/common/FilterSelectInput';
import { useState } from 'react';
import NewRecord from 'src/components/vehicles/NewRecord';
import ScreenHeader from 'src/common/ScreenHeader';
import AddIcon from '@mui/icons-material/AddOutlined';
import DownloadIcon from '@mui/icons-material/FileDownloadOutlined';
import { getReportConfig, REPORTS } from 'src/components/reports/reportService';
import ReportFilterModal from 'src/components/reports/ReportFilterModal';
import { vehicleRecordsReportFormInitialValues, vehicleRecordsReportFormModel, vehicleRecordsReportValidationSchema } from 'src/components/vehicles/vehicleRecordReportFormModel';
import useAdminSiteFilter from 'src/hooks/useAdminSiteFilter';
import usePersistentListFilters from 'src/hooks/usePersistentListFilters';

const VehicleRecords = ({ location }) => {
  const {
    search, site, setSearch, setSite
  } = usePersistentListFilters();
  const {
    isAdmin,
    siteFilter,
    setSiteFilter,
    siteOptions
  } = useAdminSiteFilter(site);
  const [openModal, setOpenModal] = useState(false);
  const [searchText, setSearchText] = useState(search);
  const [openReportModal, setOpenReportModal] = useState(false);

  const handleSearch = (str) => { setSearchText(str); setSearch(str); };
  const downloadReport = () => setOpenReportModal(true);
  const onReportModalClose = () => setOpenReportModal(false);
  const reportConfig = getReportConfig(REPORTS.vehicleRecords);

  return (
    <>
      <ScreenHeader title="Vehicle Records" />
      <Box
        sx={{
          backgroundColor: 'background.default',
          minHeight: '100%',
          py: 3
        }}
      >
        <Container maxWidth={false}>
          <FMSToolbar
            placeholder="Search Vehicle Number"
            actionName="Export"
            actionIcon={<DownloadIcon />}
            searchValue={searchText}
            onSearch={handleSearch}
            onAction={downloadReport}
            actionStyle={{ ml: 2 }}
          >
            {isAdmin && (
              <FilterSelectInput
                label="Site"
                name="site"
                value={siteFilter}
                data={siteOptions}
                onInputChange={(value) => { setSiteFilter(value); setSite(value); }}
                sx={{ width: { xs: '100%', sm: 220, md: 180 }, mr: 0 }}
              />
            )}
            <Button
              sx={{ ml: 'auto', px: 2 }}
              color="primary"
              size="large"
              variant="contained"
              startIcon={<AddIcon />}
              onClick={() => setOpenModal(true)}
            >
              Add Record
            </Button>
          </FMSToolbar>
          <ReportFilterModal
            open={openReportModal}
            title="Machinery Diesel Report"
            formModel={vehicleRecordsReportFormModel}
            formValidation={vehicleRecordsReportValidationSchema}
            formInitValues={vehicleRecordsReportFormInitialValues}
            filterConfig={reportConfig.filterOptions}
            onlyDate
            downloadUrl={reportConfig.downloadUrl}
            handleClose={onReportModalClose}
          />
          <NewRecord open={openModal} handleClose={() => setOpenModal(false)} />
          <Box sx={{ pt: 3 }}>
            <VehicleRecordTable
              refreshData={location.state?.fromDashboard}
              searchText={searchText}
              siteFilter={siteFilter}
            />
          </Box>
        </Container>
      </Box>
    </>
  );
};

VehicleRecords.propTypes = {
  location: PropTypes.object
};

export default VehicleRecords;
